<div class="wizard-container">
  <h2 class="text-center mb-4">Filtrar Pedidos de Corderos</h2>

  <!-- Filtros -->
  <div class="container mt-3">
    <div class="card filtro-card shadow-sm p-4">
      <h4 class="mb-3 text-center">Filtrar Pedidos de Corderos</h4>

      <!-- Filtros principales en una fila -->
      <div class="row g-3 align-items-end mb-3">
        <!-- Desde -->
        <div class="col-md-3 col-6">
          <label for="priFech" class="form-label">Desde:</label>
          <input
            id="priFech"
            type="date"
            class="form-control"
            [(ngModel)]="primerafecha"
          />
        </div>

        <!-- Hasta -->
        <div class="col-md-3 col-6">
          <label for="ultFech" class="form-label">Hasta:</label>
          <input
            id="ultFech"
            type="date"
            class="form-control"
            [(ngModel)]="ultimafecha"
          />
        </div>

        <!-- Cliente (Input + Select) -->
        <div class="col-md-4 col-12">
          <label for="cliente" class="form-label">Cliente:</label>
          <input
            type="text"
            class="form-control mb-1"
            placeholder="Buscar cliente..."
            [(ngModel)]="filtroCliente"
          />
          <select
            id="cliente"
            class="form-control"
            [(ngModel)]="clienteSeleccionado"
          >
            <option value="0" disabled selected>
              Seleccione un cliente...
            </option>
            <option
              *ngFor="let cli of clientes | clienteFilter: filtroCliente"
              [value]="cli.ttSocio"
            >
              {{ cli.ttNombr }}
            </option>
          </select>
        </div>

        <!-- Botón Buscar -->
        <div class="col-md-2 col-12">
          <button
            class="btn btn-success w-100"
            (click)="cargarPedidos()"
            [disabled]="!primerafecha || !ultimafecha"
          >
            Buscar
          </button>
        </div>
      </div>

      <!-- Botones de acción debajo de los filtros -->
      <div class="row g-3 mt-3">
        <div class="col-md-3 col-6">
          <button
            class="btn btn-success w-100"
            (click)="exportarAExcel()"
            [disabled]="!datosTabla || datosTabla.length === 0"
          >
            Exportar a Excel
          </button>
        </div>

        <div class="col-md-3 col-6">
          <button
            class="btn btn-warning w-100"
            *ngIf="datosTabla && datosTabla.length > 0"
            (click)="toggleModoBorrado()"
          >
            {{ modoBorrado ? "Cancelar" : "Editar/Borrar" }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Tabla desktop
  <div
    class="container-fluid mt-3 d-none d-md-block"
    *ngIf="datosTabla?.length > 0"
  >
    <h4>Pedidos de Corderos</h4>
    <table class="table table-bordered table-striped">
      <thead class="table-light">
        <tr>
          <th>Fecha</th>
          <th>Socio</th>
          <th>Nombre</th>
          <th>Explotación</th>
          <th>Hembras</th>
          <th>Machos</th>
          <th>Total</th>
          <th>Recogida</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let pedido of datosTabla">
          <td>{{ pedido.ttFecha }}</td>
          <td>{{ pedido.ttSocio }}</td>
          <td>{{ pedido.ttNombr }}</td>
          <td>{{ pedido.ttExplo }}</td>
          <td>{{ pedido.ttHembra }}</td>
          <td>{{ pedido.ttMachos }}</td>
          <td>{{ pedido.ttTotcor }}</td>
          <td>
            <span *ngIf="pedido.ttRecoge === 1">SI</span>
            <span *ngIf="pedido.ttRecoge === 0">NO</span>
            <span *ngIf="pedido.ttRecoge === 2">COOP</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
-->
  <div
    class="container-fluid mt-3 d-none d-md-block"
    *ngIf="datosTabla && datosTabla.length > 0"
  >
    <h4>Pedidos de Corderos</h4>
    <table class="table table-bordered table-striped">
      <thead class="table-light">
        <tr>
          <th>Fecha</th>
          <th>Socio</th>
          <th>Nombre</th>
          <th>Explotación</th>
          <th>Hembras</th>
          <th>Machos</th>
          <th>Total</th>
          <th>Recogida</th>
          <th *ngIf="modoBorrado" class="text-center">Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let pedido of datosTabla">
          <td>{{ pedido.ttFecha }}</td>
          <td>{{ pedido.ttSocio }}</td>
          <td>{{ pedido.ttNombr }}</td>
          <td>{{ pedido.ttExplo }}</td>
          <td>{{ pedido.ttHembra }}</td>
          <td>{{ pedido.ttMachos }}</td>
          <td>{{ pedido.ttTotcor }}</td>
          <td>
            <span *ngIf="pedido.ttRecoge === 0">SI</span>
            <span *ngIf="pedido.ttRecoge === 1">NO</span>
            <span *ngIf="pedido.ttRecoge === 2">COOP</span>
          </td>
          <td *ngIf="modoBorrado" class="text-center">
            <button
              class="btn btn-outline-primary btn-sm"
              (click)="editarLinea(pedido)"
            >
              Editar
            </button>
            <button
              class="btn btn-outline-danger btn-sm"
              (click)="borrarLinea(pedido)"
            >
              Borrar
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Cards Mobile -->
  <div class="container mt-3 d-md-none" *ngIf="datosTabla?.length > 0">
    <h4>Pedidos de Corderos</h4>
    <div class="row">
      <div class="col-12 mb-3" *ngFor="let pedido of datosTabla">
        <div class="card pedido-card shadow-sm">
          <div class="card-body">
            <p><strong>Fecha:</strong> {{ pedido.ttFecha }}</p>
            <p><strong>Socio:</strong> {{ pedido.ttSocio }}</p>
            <p><strong>Nombre:</strong> {{ pedido.ttNombr }}</p>
            <p><strong>Explotación:</strong> {{ pedido.ttExplo }}</p>
            <p><strong>Hembras:</strong> {{ pedido.ttHembra }}</p>
            <p><strong>Machos:</strong> {{ pedido.ttMachos }}</p>
            <p><strong>Total:</strong> {{ pedido.ttTotcor }}</p>
            <p>
              <strong>Recogida:</strong>
              <span *ngIf="pedido.ttRecoge === 0">SI</span>
              <span *ngIf="pedido.ttRecoge === 1">NO</span>
              <span *ngIf="pedido.ttRecoge === 2">COOP</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Mensaje cuando no hay datos -->
  <div *ngIf="datosTabla && datosTabla.length === 0">
    No hay pedidos en el rango seleccionado
  </div>

  <ng-template #modalEditar let-modal>
    <div class="modal-header">
      <h5 class="modal-title">Modificar entrega</h5>
      <button
        type="button"
        class="btn-close"
        (click)="modal.dismiss()"
      ></button>
    </div>

    <div class="modal-body">
      <label>Hembras:</label>
      <input
        type="number"
        class="form-control"
        [(ngModel)]="editPedido.ttHembra"
      />

      <label class="mt-2">Machos:</label>
      <input
        type="number"
        class="form-control"
        [(ngModel)]="editPedido.ttMachos"
      />

      <label class="mt-2">Recogida:</label>
      <select class="form-control" [(ngModel)]="editPedido.ttRecoge">
        <option [ngValue]="0">SI</option>
        <option [ngValue]="1">NO</option>
        <option [ngValue]="2">COOP</option>
      </select>
    </div>

    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="modal.dismiss()">
        Cancelar
      </button>
      <button class="btn btn-primary" (click)="guardarCambios()">
        Guardar
      </button>
    </div>
  </ng-template>
</div>
